import { DICT_KEY, getDictNameByCode, getModel, setModel } from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import supplierService from "./supplierService";
import moment from "moment";
// import {v4 as uuidv4} from "uuid"
const cacheAble = false;
const partDealModel = {
    state: {
        //查询参数
        searchParam: {},
        //配件交易频次查询列表
        customerSaleList: [],
        //配件交易频次->选中keys
        partDealListSelectedRowKeys: [],
        //配件交易频次分页
        searcnPage: {
            total: 0,
            pageNum: 1,
            pageSize: 15,
        },
        documentStatistic: {
            amountPaidTotal: null,
            amountPayableTotal: null,
            purchaseAmountTotal: "0.00",
            purchaseQuantityTotal: 0,
            saleCostTotal: null,
            saleProfitTotal: null,
        }
    },

    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = { ...state.searchParam, ...payload };
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        resetSearchParam(state, ) {
            state.searchParam = {};
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPartDealListSelectedRowKeys(state, payload) {
            state.partDealListSelectedRowKeys = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setCustomerSaleList(state, payload) {
            state.customerSaleList = payload;
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSearcnPage(state, payload) {
            state.searcnPage = payload;
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
    },

    effects: () => ({
        //加载供应商采购列表
        async loadListDetail({ showMsg = true, duration = 5, data }) {
            const funName = "加载供应商采购数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            data.supplierName = getDictNameByCode(DICT_KEY.CM_DICT.SUPPLIER, data.supplierName);
            // console.log("加载成功", data)
            const func = async () => {
                let retData = await supplierService.findPage(data);
                const {list, statistics, ...page} = retData;
                const mappedList = []

                list.forEach( (el, i) => {
                    if(el.details && el.details.length > 0){
                        el.details.forEach( ( item, index ) => {
                            let inventoryTypeName = getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, item.invoiceType),
                            orderTypeName = getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_ORDER_TYPE, item.orderType)
                            let data = {
                                key: el.id+item.id,
                                ...el,
                                ...item,
                                index: i+1,
                                inventoryTypeName,
                                orderTypeName,
                                
                                details: null,
                                rowSpanNum: index === 0 ? el.details.length : 0
                            }
                            mappedList.push(data)
                        })
                    }
                })
                
                // console.log(mappedList)
                this.setCustomerSaleList(mappedList);
                this.setSearcnPage(page);
                this.setDocumentStatistic(statistics);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //导出配件交易列表
        async exportPartDealList({ showMsg = true, duration = 5, data }) {
            const funName = "导出盘点数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log("导出成功")
            const func = async () => {
                let retData = await supplierService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
    })
};

export default partDealModel;